import { useMemo } from 'react'

const useFixedPickup = (centers, centerId, currentAddress) => {
  const firstFixedPickupTimeZone = useMemo(() => {
    const findSelectedCenter = () => centers.find(({ id }) => id === centerId)

    const findSelectedPickupAddress = center =>
      center.fixedPickupsAdresses?.find(
        fixedPickupsAddress =>
          fixedPickupsAddress.address === currentAddress?.address &&
          fixedPickupsAddress.city === currentAddress?.city &&
          fixedPickupsAddress.country === currentAddress?.country &&
          fixedPickupsAddress.postalCode === currentAddress?.postalCode,
      )

      const getNextSevenDaysTimeZones = timeZones => {
        const todayWeekDay = new Date().getDay();
        const reorderedTimeZones = [];

        if (!timeZones?.length) {
          return [];
        }
      
        for (let i = todayWeekDay; i < 7; i++) {
          reorderedTimeZones.push(timeZones[i]);
        }
      
        for (let i = 0; i < todayWeekDay; i++) {
          reorderedTimeZones.push(timeZones[i]);
        }
      
        return reorderedTimeZones;
      };

    const calculateNextTimeZone = (timeZones, daysToAddToToday) => {
      const timeZoneDate = new Date()
      timeZoneDate.setDate(timeZoneDate.getDate() + daysToAddToToday)
      return timeZones.map(timeZone => ({
        fromDate: setDateHoursAndMinutes(timeZoneDate, timeZone.fromHour),
        toDate: setDateHoursAndMinutes(timeZoneDate, timeZone.toHour),
      }))
    }

    const setDateHoursAndMinutes = (date, time = '00:00') => {
      const resultDate = new Date(date)
      const [hour, minutes] = time.split(':')
      resultDate.setHours(hour)
      resultDate.setMinutes(minutes)
      resultDate.setSeconds(0)
      return resultDate
    }

    const findNextValidTimeZone = timeZone => {
      return new Date() < timeZone.toDate
    }

    const selectedCenter = findSelectedCenter()
    const selectedPickupAddress = findSelectedPickupAddress(selectedCenter)
    const selectedPickupAddressTimeZones =
      selectedPickupAddress?.timeZones || []
    return getNextSevenDaysTimeZones(selectedPickupAddressTimeZones)
      .flatMap(calculateNextTimeZone)
      .find(findNextValidTimeZone)
  }, [centers, centerId, currentAddress])

  return { firstFixedPickupTimeZone }
}

export default useFixedPickup

export const parseCentersShippingAddress = centers => {
  // If the center address and the fixed pickup address are different, we must use the first fixed pickup address
  centers.forEach(center => {
    if (center.fixedPickupsAdresses?.length) {
      center.shippingAddress.address = center.fixedPickupsAdresses[0].address
      center.shippingAddress.city = center.fixedPickupsAdresses[0].city
      center.shippingAddress.country = center.fixedPickupsAdresses[0].country
      center.shippingAddress.postalCode =
        center.fixedPickupsAdresses[0].postalCode
    }
  })
}
